import _ from 'lodash';

import i18n from '../../../../services/i18n/i18n';
import { SURVEY_TYPES } from '../../../../utils/dataMappers';
import { shortidGenerate } from '../../../../utils/utils';

export const INITIAL_STEP = (number = 1) => ({
  isNew: true,
  number,
  translation: {
    id: '',
    language_id: '',
    title: i18n.t('default_form_data.step.title'),
  },
  questions: [],
});

export const INITIAL_QUESTION = (type, number = 1, stepId = 0) => {
  let question;
  let newData = {};
  switch (type.value) {
    case SURVEY_TYPES.multiple_choice:
      question = i18n.t('default_form_data.questions.multiple_choice.question');
      newData = {
        // list: ['Premier choix'],
        list: [{ label: i18n.t('default_form_data.questions.multiple_choice.list.firstChoice') }],
      };
      break;
    case SURVEY_TYPES.text_answer:
      question = i18n.t('default_form_data.questions.text_answer.question');
      newData = {
        answer: '',
      };
      break;
    case SURVEY_TYPES.dropdown_list:
      question = i18n.t('default_form_data.questions.dropdown_list.question');
      newData = {
        list: [
          {
            id: 1,
            type: {
              label: i18n.t('default_form_data.questions.dropdown_list.list.firstChoice'),
              isSelected: false,
            },
            value: shortidGenerate(),
          },
        ],
      };
      break;
    case SURVEY_TYPES.pdf:
      question = i18n.t('default_form_data.questions.pdf.question');
      newData = { pdf: null };
      break;
    case SURVEY_TYPES.checkbox_full:
      question = i18n.t('default_form_data.questions.checkbox_full.question');
      newData = {
        list: [{ label: i18n.t('default_form_data.questions.checkbox_full.list.firstChoice') }],
      };
      break;
    case SURVEY_TYPES.radio_multi_questions_to_table:
      question = i18n.t('default_form_data.questions.radio_multi_questions_to_table.question');
      newData = {
        list: [
          { key: shortidGenerate(), value: i18n.t('default_form_data.questions.radio_multi_questions_to_table.list.yes') },
          { key: shortidGenerate(), value: i18n.t('default_form_data.questions.radio_multi_questions_to_table.list.no') },
          { key: shortidGenerate(), value: i18n.t('default_form_data.questions.radio_multi_questions_to_table.list.notApplicable') },
          { key: shortidGenerate(), value: i18n.t('default_form_data.questions.radio_multi_questions_to_table.list.notConcerned') },
        ],
      };
      break;
    case SURVEY_TYPES.validation:
    default:
      question = i18n.t('default_form_data.questions.validation.question');
      newData = {
        first: i18n.t('default_form_data.questions.validation.data.first'),
        second: i18n.t('default_form_data.questions.validation.data.second'),
      };
      break;
  }
  const returnedQuestion = {
    isNew: true,
    translation: {
      question,
      comment: '',
      data: newData,
      desc: '',
      rewording: '',
      texte_pdf: '',
      incompris: '',
    },
    asked_more_info: null,
    step_id: stepId,
    type_id: type.id || '',
    type_name: type.value || '',
    number: number,
  };
  _.set(returnedQuestion, 'translation.data', newData);
  return returnedQuestion;
};

export const INITIAL_SURVEY = {
  is_published: false,
  translation: {
    title: '',
    description: [],
    consent_pdf_template: 'default',
  },
  type_id: '',
  speciality_id: '',
  isRadius: false,
  isSide: false,
  steps: [INITIAL_STEP(1)],
};
